<div class="modal-content">

  <div class="modal-header">
    <h5 class="modal-title" id="modal-title-login">{{'Field of interest' | translate}}</h5>
    <button tabindex="10" type="button" class="close" (click)="activeModal.close(false)">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <div class="alert alert-danger validation-error" *ngIf="showValidationError( 'selectedAreaOfInterests', '')">
      <p>{{'Select field of interest' | translate}}</p>
    </div>

    <div class="interests">

      <app-selector-areaofinterests [maxAmount]="maxAmount" [(ngModel)]="selectedAreaOfInterests"></app-selector-areaofinterests>

    </div>

  </div>

  <div class="modal-footer">
    <div class="btn-toolbar flex-grow-1 justify-content-between">
      <button type="button" class="btn btn-outline-secondary" (click)="activeModal.close(false)">{{'Back' | translate}}</button>
      <button type="button" class="btn btn-primary" (click)="Save()">{{'Save' | translate}}</button>
    </div>
  </div>
</div>

